// Explicit marketing events only; financial screens never emit advertising events.
export const META_PIXEL_ID = '1114019658037366';
const sent = new Set();
export function metaCheckoutContext() {
  const context = {};
  document.cookie.split(';').forEach(entry => {
    const [name, ...parts] = entry.trim().split('=');
    if (name === '_fbp' || name === '_fbc') {
      try {
        const value = decodeURIComponent(parts.join('='));
        if (/^fb\.\d+\.\d+\.[A-Za-z0-9_.-]{1,400}$/.test(value)) context[name.slice(1)] = value;
      } catch (_) { /* Ignore malformed browser cookies. */ }
    }
  });
  return context;
}

const PURCHASE_KEY = 'aorra:meta-purchases:v1';

export function isMetaPage(location = window.location) {
  if (!['/', '/login', '/dashboard/planes'].includes(location.pathname)) return false;
  return [...new URLSearchParams(location.search).keys()].every(key =>
    /^utm_/.test(key) || ['fbclid', 'status', 'ref_payco', 'x_ref_payco', 'payment_id', 'collection_id',
      'collection_status', 'preference_id', 'merchant_order_id',
      'payment_type', 'site_id', 'processing_mode', 'merchant_account_id'].includes(key));
}

export function initializeMetaPixel() {
  if (!isMetaPage()) return false;
  if (!window.__aorraMetaInitialized) {
    if (!window.fbq) {
      const fbq = function () {
        if (fbq.callMethod) fbq.callMethod.apply(fbq, arguments);
        else fbq.queue.push(arguments);
      };
      fbq.push = fbq; fbq.loaded = true; fbq.version = '2.0'; fbq.queue = [];
      window.fbq = fbq; window._fbq = fbq;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      script.referrerPolicy = 'no-referrer';
      document.head.appendChild(script);
    }
    window.fbq('set', 'autoConfig', false, META_PIXEL_ID);
    window.fbq('init', META_PIXEL_ID);
    window.__aorraMetaInitialized = true;
  }
  return true;
}

export function trackMetaPageView() {
  if (!initializeMetaPixel()) return false;
  window.fbq('trackSingle', META_PIXEL_ID, 'PageView');
  return true;
}

export function trackInitiateCheckout(checkout, planId, eventId) {
  const value = Number(checkout?.amount);
  const currency = String(checkout?.currency || '').toUpperCase();
  if (!Number.isFinite(value) || value <= 0 || !/^[A-Z]{3}$/.test(currency) || !initializeMetaPixel()) return false;
  const key = `checkout:${eventId}`;
  if (sent.has(key)) return false;
  window.fbq('trackSingle', META_PIXEL_ID, 'InitiateCheckout', {
    value, currency, content_ids: [planId], content_type: 'product', num_items: 1,
  }, { eventID: eventId });
  sent.add(key);
  return true;
}

export function trackVerifiedPurchase(purchase) {
  if (purchase?.event_name !== 'Purchase' || !/^[a-f0-9]{64}$/.test(purchase.event_id || '')
      || typeof purchase.value !== 'number' || !Number.isFinite(purchase.value) || purchase.value <= 0
      || !/^[A-Z]{3}$/.test(purchase.currency || '') || !initializeMetaPixel()) return false;
  let previous = [];
  try { previous = JSON.parse(localStorage.getItem(PURCHASE_KEY) || '[]'); } catch (_) { /* storage unavailable */ }
  if (!Array.isArray(previous)) previous = [];
  if (sent.has(purchase.event_id) || previous.includes(purchase.event_id)) return false;
  window.fbq('trackSingle', META_PIXEL_ID, 'Purchase', {
    value: purchase.value, currency: purchase.currency,
  }, { eventID: purchase.event_id });
  sent.add(purchase.event_id);
  try { localStorage.setItem(PURCHASE_KEY, JSON.stringify([...previous, purchase.event_id].slice(-200))); } catch (_) { /* best effort */ }
  return true;
}

export async function verifyAndTrackPurchase(api, provider, reference) {
  if (!reference || !isMetaPage()) return false;
  try {
    const { data } = await api.post('/billing/meta-purchase', { provider, reference }, { timeout: 20000 });
    if (data.purchase?.event_id && sent.has(data.purchase.event_id)) return true;
    return trackVerifiedPurchase(data.purchase);
  } catch (_) { return false; }
}
